import jsonLogic  from 'json-logic-js'

import { get as _get, isUndefined as _isUndefined, map as _map, set as _set, 
    setWith as _setWith, countBy as _countBy, pick as _pick, sumBy as _sumBy, values as _values, toNumber as _toNumber, 
  intersection as _intersection} from 'lodash-es'

export const exists = (data, rule) => {
  return data.every(val => rule.includes(val));
}
jsonLogic.add_operation('exists', exists)

export const maxCountJsonTransformation = (data, rule) => {
  const groupedByCounts = _countBy(data);
  const jsonTranformation = _pick(groupedByCounts, ['ENTITY_EXTRACTION_CHAIN_NODE', 'PAGINATION_METADATA_CHAIN_NODE'])
  return _sumBy(_values(jsonTranformation), (o) => _toNumber(o || 0)) <= rule
}
jsonLogic.add_operation('maxCountJsonTransformation', maxCountJsonTransformation)

export const maxCountPaginationController = (data, rule) => {
  const groupedByCounts = _countBy(data);
  const paginationController = _pick(groupedByCounts, ['NONE_PAGINATION_CONTROLLER_NODE', 'OFFSET_BASED_PAGINATION_CONTROLLER_NODE', 'PAGE_BASED_PAGINATION_CONTROLLER_NODE', 'CURSOR_BASED_PAGINATION_CONTROLLER_NODE'])
  return _sumBy(_values(paginationController), (o) => _toNumber(o || 0)) <= rule
}

jsonLogic.add_operation('maxCountPaginationController', maxCountPaginationController)

export const maxCountAuthenticationController = (data, rule) => {
  const groupedByCounts = _countBy(data);
  const authenticationController = _pick(groupedByCounts, ["NONE_AUTHENTICATION_CONTROLLER_NODE", "STATIC_AUTHENTICATION_CONTROLLER_NODE", "TWO_STEP_AUTHENTICATION_CONTROLLER_NODE"])
  return _sumBy(_values(authenticationController), (o) => _toNumber(o || 0)) <= rule
}

jsonLogic.add_operation('maxCountAuthenticationController', maxCountAuthenticationController)

export const maxCountGcsCacheEntitySource = (data, rule) => {
  const groupedByCounts = _countBy(data);
  const gcsCacheTranformation = _pick(groupedByCounts, ['GCS_CACHE_ENTITY_TRANSFORMATION_OPS_NODE'])
  const entitySources = _pick(groupedByCounts, ['API_ENTITY_SOURCE_NODE', 'PREDEFINED_ENTITIES_ENTITY_SOURCE_NODE', 'GCS_CACHE_ENTITY_SOURCE_NODE', 'REPORT_ENTITY_SOURCE_NODE'])
  return _sumBy(_values(gcsCacheTranformation), (o) => _toNumber(o || 0)) == rule || _sumBy(_values(entitySources), (o) => _toNumber(o || 0)) == rule
}

jsonLogic.add_operation('maxCountGcsCacheEntitySource', maxCountGcsCacheEntitySource)

export const intersection = (data, rule) => {
  return _intersection(data, rule).length > 0;
}
jsonLogic.add_operation('intersection', intersection)


export const jsonDSL = jsonLogic;